/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { Copy, Title, Group, BodyCopy, Button, SelectableList } from '@insticator/insticator-ui';
// styles
import injectSheet from 'react-jss';
import styles from './selectpayment_styles';


/* ========== ~~~~~~~~~~ SELECT PAYMENT ~~~~~~~~~~ ========== */
const SelectPayment = injectSheet(styles)((props) => {

  const { selectPayment, selectedPayment, savedPaymentTypes, moveBack, moveForward } = props

  const handleChangePaymentType = value => selectPayment(value)

  return (
    <div className={`selectpayment ${props.classes.selectpayment}`}>
      <Copy name={`page-copy`}>
          <Title variant={'withctas'}>
              <h2>Payment Information </h2>
              <Group name={`controls`}>
                <Button variant={'system'} text={'Back'} handleClick={moveBack} />
                <Button variant={'primary'} text={'Continue'} handleClick={moveForward} disabled={!selectedPayment} />
              </Group>
          </Title>
          <BodyCopy>
              <p>Select a Payment Method</p>
          </BodyCopy>
      </Copy>
      <Group name={`page-details`}>
          <SelectableList type={'fancyradio'}
              items={[{ value: 'PAYPAL', text: 'PayPal' },
              { value: 'CHECK', text: 'Check (US Only)' },
              { value: 'ACH', text: 'Direct Deposit / ACH (US only)' },
              { value: 'WIRE', text: 'Wire Transfer (international payment method)' }]}
              selected={selectedPayment}
              disabled={savedPaymentTypes}
              handleChange={handleChangePaymentType} />
      </Group>
    </div>
  )
});

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default SelectPayment